
import { ScoreReport } from '@/interface/report.interface';
import { defineComponent, PropType } from 'vue';
import uiTitleVue from './uiTitle.vue';

export default defineComponent({
  components: {
    uiTitleVue,
  },
  props: {
    data: Object as PropType<ScoreReport>,
  },
  setup() {
    return {
    };
  },
});
